<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed" >
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>资产</el-breadcrumb-item>
        </el-breadcrumb>
        <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
        <el-option
            v-for="item in DianList"
            :key="item.ID"
            :label="item.StoresName"
            :value="item.ID">
        </el-option>
        </el-select>
    </div>
    <div style="width：100%;padding-top:50px">
        <div class="flex-spc-x" style="width:100%">
            <div class="box cursor">
                    <div class="textTitle">资产账户     
                    <el-tooltip class="item" effect="dark" content="截止至今日8:30账户总金额(扣除已提现部分)" placement="top-start">
                        <i class="el-icon-question" style="color:#808080"></i>
                        <!-- <el-button>上左</el-button> -->
                        </el-tooltip>
                    </div>
                    <div class="flexc-cen-x money">
                        <div class="rmb">￥</div>
                        <div class=""> {{list.allAmount}}</div>
                    </div>
                    <!-- <div class="bottomTitle">昨日收入 ￥{{list.allsumAmountzt}} </div> -->
                    
            </div>
            <div class="box cursor">
                    <div class="textTitle">今日收益
                    <el-tooltip class="item" effect="dark" content="次日8:30结算入账到资金池" placement="top-start">
                        <i class="el-icon-question" style="color:#808080"></i>
                        <!-- <el-button>上左</el-button> -->
                        </el-tooltip>
                    </div>
                    <div class="flexc-cen-x money">
                        <div class="rmb">￥</div>
                        <div class=""> {{list.allAmountjt}}</div>
                    </div>
                    <div class="bottomTitle">实付金额 </div>
                    
            </div>
            <div class="boxx cursor">
                    <div class="textTitle">退款总金额   
                    <el-tooltip class="item" effect="dark" content="区分为今日订单退款和非今日订单退款" placement="top-start">
                        <i class="el-icon-question" style="color:#808080"></i>
                        <!-- <el-button>上左</el-button> -->
                        </el-tooltip>
                    </div>
                    <div class="flex-spc-x" style="width:80%;">
                        <div>
                            <div class="flexc-cen-x money">
                                <div class="rmb">￥</div>
                                <div class="">{{list.allAmountjttk}}</div>
                            </div>
                            <div class="bottomTitle">今日订单 </div>
                        </div>
                        <div>
                            <div class="flexc-cen-x money">
                                <div class="rmb">￥</div>
                                <div class="">{{list.allAmountcjttk}}</div>
                            </div>
                            <div class="bottomTitle">非今日订单</div>
                        </div>
                    </div>
                    
                    
                    
            </div>
            <div class="box cursor">
                    <div class="textTitle">已提现金额  
                    <el-tooltip class="item" effect="dark" content="已提现的所有金额" placement="top-start">
                        <i class="el-icon-question" style="color:#808080"></i>
                        <!-- <el-button>上左</el-button> -->
                        </el-tooltip>
                    </div>
                    <div class="flexc-cen-x money">
                        <div class="rmb">￥</div>
                        <div class="">{{list.sumAmount}}</div>
                    </div>
                    <div class="bottomTitle flexc-cen-x">线上支付：<img src="../../assets/icon/wpay.png" style="width:20px;height:20px" alt="" srcset=""> </div>
                    
            </div>
            <div class="box cursor">
                    <div class="textTitle">可提现余额(元)    
                    <el-tooltip class="item" effect="dark" content="可提现余额=资金池-非今日订单退款-待结算金额" placement="top-start">
                        <i class="el-icon-question" style="color:#808080"></i>
                        <!-- <el-button>上左</el-button> -->
                        </el-tooltip>
                    </div>
                    <div class="flexc-cen-x money">
                        <div class="rmb">￥</div>
                        <div class="">{{list.syallAmount}}</div>
                    </div>
                    <div class="bottomTitle"> <el-button type="primary" v-if=" q2== true" size="mini" @click="toWithdraw()">提现</el-button> </div>
                    
            </div>
        </div>
      <!-- <div class="flex-spc-x" style="width:100%">
        <div class="box1">
          <div class="flex-spc-x">
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:95%;height:25%">
                  <div class="box3Ttile">今日需服务人数</div>
                  <el-button type="text" style="font-size: 14px;">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                     {{list.qxhxcount}}
                    </div>
                </div>
            </div>
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:95%;height:25%">
                  <div class="box3Ttile">今日已服务人数</div>
                  <el-button type="text" style="font-size: 14px;">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                      {{list.yhxcount}}
                    </div>
                </div>
            </div>
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:95%;height:25%">
                  <div class="box3Ttile">今日待服务人数</div>
                  <el-button type="text" style="font-size: 14px;">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                       {{list.dhxcount}}
                    </div>
                </div>
            </div>
            <div class="box3 flex-xy">
                <div class="flex-spc-x" style="width:95%;height:25%">
                  <div class="box3Ttile">短信条数</div>
                  <el-button type="text" style="font-size: 14px;">更多</el-button>
                </div>
                <div class="flex-xy" style="width:95%;height:75%">
                    <div class="num" style="margin-top:-10px">
                      0
                    </div>
                </div>
            </div>
          </div>
          <div class="flex-spc-x">
             <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
              <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
                          <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
                          <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
          </div>
          <div class="flex-spc-x">
             <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
              <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
                          <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
                          <div class="box4 flex-xy">
               <img src="../../assets/yy.png" style="height:50px;width:50px" alt="" srcset="">
               <div class="textTitle" style="margin-top:10px;font-size:15px;font-weight:500">预约</div>
             </div>
          </div>
        </div>
         <div class="box2">
            <h4 class="pm">服务预约排名(截止至昨天)</h4>
            <ul class="rankingList___2qU5M">
              <li style="width:100%" v-for="(items,index) in list.listProject">
                <span class="active___3n5dI" v-if="index < 3">{{index + 1}}</span>
                 <span class="">{{index + 1}}</span>
                <span >{{items.ProjectName}}</span>
                <span style="margin-right:10px">{{items.allCount}}次</span>
              </li>
             
            </ul>
         </div>
      </div>
       <div class="flexc-cen-x" style="width:100%">
        <div class="box5 flex-xy">
          <div class="box3Ttile">小程序二维码</div>
          <img :src="list.xcxqcode" style="width:100px;height:100px;margin-top:15px" alt="" srcset="">
          <div class="bottomTitle1">微信扫描查看</div>
        </div>
        <div class="box5 flex-xy" style="margin-left:1.5%">
          <div class="box3Ttile">客服二维码</div>
          <img :src="list.kfqcode" style="width:100px;height:100px;margin-top:15px" alt="" srcset="">
          <div class="bottomTitle1">微信扫描查看</div>
        </div>
       </div> -->
    </div>
    <el-alert
        type="info"
        show-icon
        :closable="false"
    >
        <div>1.提现腾讯微信平台会收取1%的手续费，预约小宝不收取任何手续费。</div>
        <div style="margin-top:5px">2.非工作日（周末）不支持提现，非工作日（周末）产生订单会在下一个工作日进行资金结算业务。</div>
        <div style="margin-top:5px">3.第三方支付平台（扫呗）的结算周期为D+3，提现申请后，3个自然日内款项会自动转至您在支付设置填写的银行账户。</div>
    </el-alert>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="提现记录" name="0" v-if="q3 == true">
            <!-- <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                </el-select>&nbsp;&nbsp;
                                 
                                <el-date-picker
                                    size="mini"
                                        is-range
                                        v-model="firstdate8"
                                        :disabled="stype !='4'"
                                         value-format="yyyy-MM-dd"
                                        type="daterange"
                                        range-separator="至"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间"
                                        style="width:270px;"
                                        @change='selectDat8'
                                ></el-date-picker> 
                                <el-select v-model="productId" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="全部" value="0"></el-option>
                                    <el-option label="商品" value="3"></el-option>
                                    <el-option label="购卡" value="4"></el-option>
                                    <el-option label="续卡" value="5"></el-option>
                                    <el-option label="活动" value="1"></el-option>
                                    <el-option label="购课" value="9"></el-option>
                                </el-select>&nbsp;&nbsp;
                                <el-input size="mini"  placeholder="请输入订单号" style="width:220px" v-model="searchContent" ></el-input>&nbsp;&nbsp;
                                <el-button size="mini" type="primary" @click="handleSearchCoursetopsy">搜索</el-button>
                              
                                                                
                            </div>
                </div>
            </div> -->
            <el-table :data="withList" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                    <el-table-column label="提现时间" prop="addTime"></el-table-column>
                                <el-table-column label="提现金额" prop="Amount"></el-table-column>
                                <el-table-column label="提现手续费" prop="sxf"></el-table-column>
                                <el-table-column label="到手金额" prop="sxf">
                                    <template slot-scope="scope"  >
                                        {{scope.row.Amount - scope.row.sxf }}
                                        </template>
                                </el-table-column>
                                <el-table-column label="审批状态" prop="EvaluateType">
                                    <template slot-scope="scope"  >
                                        <el-badge value="申请中" type="error" v-if="scope.row.zt =='0'"></el-badge>
                                        <el-badge value="已提现" type="success" v-if="scope.row.zt =='1'"></el-badge>
                                        <el-badge value="已驳回" type="error" v-if="scope.row.zt =='2'"></el-badge>
                                </template>
                                </el-table-column> 
                                <el-table-column label="审批时间" prop="EvaluateType">
                                    <template slot-scope="scope"  >
                                        <span v-if="scope.row.zt !='0'">{{scope.row.updTime}}</span>
                                </template>
                                </el-table-column> 
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </el-tab-pane>
      <el-tab-pane label="充值记录" name="1" v-if="q4 == true">
            <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                </el-select>&nbsp;&nbsp;
                                 
                                                               <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    至
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker>
                                <el-select v-model="productId" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="全部" value="0"></el-option>
                                    <el-option label="商品" value="3"></el-option>
                                    <el-option label="购卡" value="4"></el-option>
                                    <el-option label="续卡" value="5"></el-option>
                                    <el-option label="活动" value="1"></el-option>
                                    <el-option label="购课" value="9"></el-option>
                                </el-select>&nbsp;&nbsp;
                                <el-input size="mini"  placeholder="请输入订单号" style="width:220px" v-model="searchContent" ></el-input>&nbsp;&nbsp;
                                <el-button size="mini" type="primary" @click="handleSearchCoursetopsy">搜索</el-button>
                              
                                                                
                            </div>
                </div>
            </div>
            <el-table :data="moneyList" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                       <el-table-column label="创建时间"  prop="AddTime" ></el-table-column>
                            <el-table-column label="订单号" prop="outTradeNo" ></el-table-column>
                            <el-table-column :label="WZHYName+'姓名'" prop="Name" ></el-table-column>
                            <el-table-column :label="WZHYName+'手机'" prop="Phone" ></el-table-column>
                           <el-table-column label="购买类型" prop="PayType" ></el-table-column>
                            <el-table-column label="购买信息" prop="userName" ></el-table-column>
                            <el-table-column label="订单金额"  prop="Amount" ></el-table-column>
                             <el-table-column label="退款金额"  prop="Amount" >
                                  <template slot-scope="scope"  >
                                      <span v-if="scope.row.zt ==2">{{scope.row.Amount}}</span>
                                      <span v-if="scope.row.zt ==1">0.00</span>
                                </template>
                             </el-table-column>

                            <el-table-column label="付款状态" prop="zt">
                                 <template slot-scope="scope"  >
                                  <el-badge value="已付款" type="success" v-if="scope.row.zt ==1"></el-badge>
                                   <el-badge value="已退款" type="error" v-if="scope.row.zt ==2"></el-badge>
                                </template>
                            </el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


       

      </el-tab-pane>
      <el-tab-pane :label="WZHYName+'消费记录'" name="2"  v-if="q5 == true">
         <div class="listWrap">
                <div class="flexB" style="margin-bottom:10px;">
                            <div class="flexS">
                                  <el-select v-model="stype" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="今天" value="0"></el-option>
                                    <el-option label="昨天" value="1"></el-option>
                                    <el-option label="本周" value="2"></el-option>
                                    <el-option label="本月" value="3"></el-option>
                                    <el-option label="自定义" value="4"></el-option>
                                </el-select>&nbsp;&nbsp;
                                 
                                                                <el-date-picker
                                    v-model="firstdate8[0]"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    format="yyyy 年 MM 月 dd 日"
                                    :disabled="stype !='4'"
                                    value-format="yyyy-MM-dd"
                                    style="width:170px"
                                     @change='selectDat8'
                                    >
                                  </el-date-picker>
                                    至
                                  <el-date-picker
                                    v-model="firstdate8[1]"
                                    :disabled="stype !='4'"
                                    type="date"
                                    placeholder="选择日期"
                                    size="mini"
                                    style="width:170px"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                     @change='selectDat9'
                                    >
                                  </el-date-picker>
                                <el-select v-model="productId" @change="handleSearchCoursetopsy" size="mini">
                                    <el-option label="全部" value="0"></el-option>
                                    <el-option label="商品" value="3"></el-option>
                                    <el-option label="购卡" value="4"></el-option>
                                    <el-option label="续卡" value="5"></el-option>
                                    <el-option label="活动" value="1"></el-option>
                                    <el-option label="购课" value="9"></el-option>
                                </el-select>&nbsp;&nbsp;
                                <el-input size="mini"  placeholder="请输入订单号" style="width:220px" v-model="searchContent" ></el-input>&nbsp;&nbsp;
                                <el-button size="mini" type="primary" @click="handleSearchCoursetopsy">搜索</el-button>
                              
                                                                
                            </div>
                </div>
            </div>
            <el-table :data="thyList" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
                       <el-table-column label="创建时间"  prop="AddTime" ></el-table-column>
                            <el-table-column label="订单号" prop="outTradeNo" ></el-table-column>
                            <el-table-column :label="WZHYName+'姓名'" prop="Name" ></el-table-column>
                            <el-table-column :label="WZHYName+'手机'" prop="Phone" ></el-table-column>
                           <el-table-column label="购买类型" prop="PayType" ></el-table-column>
                            <el-table-column label="购买信息" prop="userName" ></el-table-column>
                            <el-table-column label="订单金额"  prop="Amount" ></el-table-column>
                             <el-table-column label="退款金额"  prop="Amount" >
                                  <template slot-scope="scope"  >
                                      <span v-if="scope.row.zt ==2">{{scope.row.Amount}}</span>
                                      <span v-if="scope.row.zt ==1">0.00</span>
                                </template>
                             </el-table-column>

                            <el-table-column label="付款状态" prop="zt">
                                 <template slot-scope="scope"  >
                                  <el-badge value="已付款" type="success" v-if="scope.row.zt ==1"></el-badge>
                                   <el-badge value="已退款" type="error" v-if="scope.row.zt ==2"></el-badge>
                                </template>
                            </el-table-column>
                             <el-table-column align="center" label="操作"  >
                                  <template slot-scope="scope">
                                      <el-button size="mini" type="success" v-if="scope.row.zt == 1 && q6 == true" @click="tk(scope.row)" >退款</el-button>
                                  </template>
                             </el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
    </el-tabs>

    <el-drawer :wrapperClosable= false
      title="提现"
      :visible.sync="show"
      :direction="direction"
      size="30%"
    >
       <div class="ant-row flexc-cen-x" style="margin-left:42px">
           <div class="ant-title" style="font-size:14px;">可提现余额:</div>
           <div style="font-size:14px;margin-left:10px">￥{{list.syallAmount}}</div>
        </div>
        <!-- <div class="ant-row flexc-cen-x" style="margin-left:42px">
           <div class="ant-title" style="font-size:14px;">到账金额:</div>
           <div style="font-size:14px;margin-left:10px">￥0</div>
        </div> -->
       <el-form ref="form" :model="editForm" label-width="120px">

        <el-form-item label="提现金额：">
            <el-input type="number" v-model="syallAmount" style="width:200px" size="mini"></el-input> 元
        </el-form-item>


       </el-form>
       <div class="ant-row flexc-cen-x" style="margin-left:30px;margin-top:-20px">
           <div class="ant-title" style="font-size:14px;">已提现金额:</div>
           <div style="font-size:14px;margin-left:10px">￥{{list.allAmount}}</div>
        </div>
        <div class="ant-row flexc-cen-x" style="margin-left:30px;margin-top:20px">
           <div class="ant-title" style="font-size:12px;">1. 每笔提现金额至少<span style="color:black">10元</span>；</div>
        </div>
        <div class="ant-row flexc-cen-x" style="margin-left:30px;margin-top:-10px">
           <div class="ant-title" style="font-size:12px;">2. 每日可提现一次，无提现上限；</div>
        </div>
        <div class="ant-row flexc-cen-x" style="margin-left:30px;margin-top:-10px">
           <div class="ant-title" style="font-size:12px;">3. 提现结算时间为<span style="color:black">T+1,</span>提现款项入账至支付设置账号；</div>
        </div>
        <div class="ant-row flexc-cen-x" style="margin-left:30px;margin-top:-10px">
           <div class="ant-title" style="font-size:12px;">4. 非工作日（周末）不支持提现；</div>
        </div>
        <div class="ant-row flexc-cen-x" style="margin-left:30px;margin-top:-10px">
           <div class="ant-title" style="font-size:12px;">5. 如需帮助请联系客服。</div>
        </div>
        <div class="demo-drawer__footer flex-r-x" style="width:30%">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button
            style="margin-right:20px"
                size="small"
                type="primary"
                @click="sendWithdrawal"
                >提现</el-button
            >
        </div>
    </el-drawer>

    <!-- 搜索筛选 -->
  </div>
</template>
<script>

import Pagination from "../../components/Pagination";
 import { baseUrl } from "../../config/env.js";
 import { ajax } from "../../config/fetch.js";
 import {getLoginToken} from "@/api/getData";
export default {
  data() {
    return {
      open:true,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      SelectStoresID:localStorage.getItem("StoresID"),
      list:[],
 
      direction: "ltr",
      activeName:'0',
      money:0,
      stype:"2",
      minDate8:'',
      maxDate8:'',
      productId:'0',
      firstdate8:[],
      title: "添加",
      withList:[],
      moneyList:[],
      thyList:[],
      searchContent:'',
      syallAmount:0, 
      sxf:'',
      editForm: {
        deptId: "",
        deptName: "",
        deptNo: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: "请输入部门名称", trigger: "blur" },
        ],
        deptNo: [
          { required: true, message: "请输入部门代码", trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      show:false,
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
      if(localStorage.getItem('isAdmin') == 1){  

          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 =true
          this.q7 = true

      }
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 121)
            this.q1  =true
            if(items == 122)
            this.q2 = true
            if(items == 123)
            this.q3 = true
            if(items == 124)
            this.q4 = true
            if(items == 125)
            this.q5= true
          if(items == 126)
            this.q6 = true
      })
      if(this.q3 == false && this.q4 == true)
      this.activeName == '1'
      if(this.q3 == false && this.q4 == false && this.q5 == true)
      this.activeName == '2'
      
        this.getDianList()
        this.getList()
        this.getListWithdrawal()
        this.getListMoneyManagement()
        // this.getListMoneyManagementhy()
      // this.getdata(this.formInline);
      // this.getLoginToken()
      //  const loading = this.$loading({
      //       lock: true,
      //       text: '加载中...',
      //       spinner: 'el-icon-loading',
      //       background: 'rgba(0, 0, 0, 0.7)'
      //     });
      //     // setTimeout(() => {
      //     //   loading.close();
      //     // }, 2000);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    tk(items){
       this.$confirm("确定要退款吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              MID:items.ID,
              loginID:localStorage.getItem("LoginID"),
   
            }
            var that = this
            this.ajax('MoneyManagementTK.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "退款成功",duration:2000,
                  });
            
                  that.getListMoneyManagementhy()
                  that.getList()
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {

            });
    },
      sendWithdrawal(){
        if(this.syallAmount > 1 && !(this.syallAmount>this.list.syallAmount)){
                let sxf = (this.syallAmount *0.01 ).toFixed(2);
                this.sxf =sxf;
                let dsje= (this.syallAmount -this.sxf ).toFixed(2);
                this.$confirm('提现金额为'+this.syallAmount +'元，到手金额为'+dsje+'元，确定提现吗?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                      }).then(() => {
                          this.addWithdrawal();
                      }).catch(() => {
                                
                    });
                }else{

                     this.$message({ type: "error", message: "请输入正确提现金额" ,duration:1000});

                }
             
            },
    getListWithdrawal(){
            var data = { 
                        SelectStoresID:this.SelectStoresID,
                        token: localStorage.getItem("token"),
                        StoresID:localStorage.getItem("StoresID"),
                        pages:this.formInline.page,
                        psize:this.formInline.limit,

                      
                }
                    var that = this
                this.ajax('getListWithdrawal.aspx',JSON.stringify(data),"POST",function(res){
                    if (res.orsuccess == "1") {
                        that.withList =res.data      
                        that.pageparm.total = res.allcount   
                     
                    }
                })
    },
    getListMoneyManagement(){
            var data = { 
                        SelectStoresID:this.SelectStoresID,
                        token: localStorage.getItem("token"),
                        StoresID:localStorage.getItem("StoresID"),
                        pages:this.formInline.page,
                        psize:this.formInline.limit,
                        stype:this.stype,
                        Stime:this.minDate8,
                        Etime:this.maxDate8,
                        productId:this.productId,
                        outTradeNo:this.searchContent
                }
            var that = this
        this.ajax('getListMoneyManagement.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                that.moneyList =res.data         
                that.pageparm.total = res.allcount
                 var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
            }
        })
    },
    getListMoneyManagementhy(){
           var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:this.formInline.page,
            psize:this.formInline.limit,
            stype:this.stype,
            Stime:this.minDate8,
            Etime:this.maxDate8,
            productId:this.productId,
           outTradeNo:this.searchContent
      }
        var that = this
       this.ajax('getListMoneyManagementhy.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.thyList =res.data       
               that.pageparm.total = res.allcount
                 var Stime = res.Stime;
                var Etime = res.Etime;
                that.firstdate8 = [Stime,Etime];
           }
        })
    },
    addWithdrawal(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
        Amount:this.syallAmount ,
            sxf:this.sxf 

      }
        var that = this
       this.ajax('addWithdrawal.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              
               that.show = false
              that.getList()
              that.getListWithdrawal()
            }

      })
    },
    handleSearchCoursetopsy(){
              if(this.stype=='4' ){
                    if(this.minDate8 !='' && this.maxDate8 !=''){
                         
                  
                            if(this.activeName  == 0){
                        this.getListWithdrawal()

                    } 
                    if(this.activeName  == 1){
                            this.getListMoneyManagement()
                
                    }
                    if(this.activeName  == 2){
                        this.getListMoneyManagementhy()
                    }
                    }
                }else{
              
                   if(this.activeName  == 0){
                        this.getListWithdrawal()

                        } 
        if(this.activeName  == 1){
                  this.getListMoneyManagement()
       
        }
        if(this.activeName  == 2){
            this.getListMoneyManagementhy()
        }

        }
    },


    selectDat8(e){
               console.log(this.firstdate8)
              this.maxDate8 = this.firstdate8[1]
              this.minDate8 = e
            if( this.minDate8 > this.maxDate8){
           
              console.log(this.maxDate8)
              this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
                    return;
                
            }
                if(this.activeName  == 0){
            this.getListWithdrawal()

        } 
        if(this.activeName  == 1){
                  this.getListMoneyManagement()
       
        }
        if(this.activeName  == 2){
            this.getListMoneyManagementhy()
        }    
    },
        selectDat9(e){
              this.minDate8 = this.firstdate8[0]
              this.maxDate8 = e
            if( this.minDate8 > this.maxDate8){
              console.log(this.minDate8)
              console.log(this.maxDate8)
              this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
                    return;
                
            }
                if(this.activeName  == 0){
            this.getListWithdrawal()

        } 
        if(this.activeName  == 1){
                  this.getListMoneyManagement()
       
        }
        if(this.activeName  == 2){
            this.getListMoneyManagementhy()
        }    
    },
    toWithdraw(){
        this.show = true
    },
        // 分页插件事件
    callFather(parm){
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
       if(this.activeName  == 0){
            this.getListWithdrawal()

        } 
        if(this.activeName  == 1){
                  this.getListMoneyManagement()
       
        }
        if(this.activeName  == 2){
            this.getListMoneyManagementhy()
        }
    },
    getListMembersPreAboutZJ(){

    },
    getListMembersPreAbout(){

    },
      handleClick(){
        this.stype="2";
        this.minDate8='';
		this.maxDate8='';
        this.searchContent = ''
        this.productId = '0'
        this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
        }
        if(this.activeName  == 0){
            this.getListWithdrawal()

        } 
        if(this.activeName  == 1){
                  this.getListMoneyManagement()
       
        }
        if(this.activeName  == 2){
            this.getListMoneyManagementhy()
        }
    },
    getList(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
      const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
        var that = this
       this.ajax('getMoneyManagementinfo.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.list =res.data
               
            }
            loading.close();
      })
    },
    changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getList()
      // this.getImg()
    },
      getDianList(){
       var data = { 
          SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },
 
 
  


    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.deptId = row.deptId;
        this.editForm.deptName = row.deptName;
        this.editForm.deptNo = row.deptNo;
      } else {
        this.title = "添加";
        this.editForm.deptId = "";
        this.editForm.deptName = "";
        this.editForm.deptNo = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          deptSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("公司保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deptDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("公司删除失败，请稍后再试！");
            });
        })
        .catch(() => {
            ;
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>
<style scoped>
.ant-title{
        color: #999;
        font-size:12px;
}
.ant-row{
    margin-bottom: 12px;
}

.rankingList___2qU5M li span:last-child {
    float: right;
}
.rankingList___2qU5M li span.active___3n5dI {
    background-color: #fab938 !important;
    color: #fff !important;
}
.rankingList___2qU5M li span:first-child {
    background-color: #f5f5f5;
    border-radius: 20px;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    margin-right: 10px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    color:black;
}
.rankingList___2qU5M li{
    zoom: 1;
    margin-top: 16px;
}
.rankingList___2qU5M li span {
    color: rgba(0,0,0,.65);
    font-size: 12px;
    line-height: 22px;
}
.rankingList___2qU5M {
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
    height: 300px;
    overflow:auto;
}
.bottomTitle{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    line-height: 20px;
}
.bottomTitle1{
    margin-top: 12px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666;
    /* line-height: 20px; */
}
.rmb{
  font-size: 12px; line-height: 1;
}
.money{
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    margin-top: 12px;
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
}
.textTitle{
    margin-right: 4px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
    line-height: 22px;
}
 .box{
    cursor: pointer;
    width: 17%;
    height: 150px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
   .boxx{
    cursor: pointer;
    width: 25%;
    height: 150px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .box1{
 
    width: 74.7%;
    height: 362px;
    /* padding: 20px; */
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    /* border: 1px solid #ececec; */
    /* box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%); */
  }
  .box2{
    cursor: pointer;
    width: 24%;
    height: 362px;
    padding: 10px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .pm{
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: "tnum";
    margin-top: 0;
    margin-bottom: 0.5em;
    color: rgba(0,0,0,.85);
    font-weight: 500;
  }

 .box3{
    cursor: pointer;
    width: 24%;
    height: 130px;
    
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
  .box3Ttile{
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #191919;
  }
  .num{
    font-family: PingFangSC-Medium;
    font-size: 28px;
    color: #4c4c4c;
    line-height: 46px;
  }
   .box4{
    cursor: pointer;
    width: 24%;
    height: 100px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
   border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
 .box5{
    cursor: pointer;
    height: 200px;
    width:180px;
    box-sizing: border-box;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
  }
</style>

 



// WEBPACK FOOTER //
// src/views/finance/finance.vue